import { render, staticRenderFns } from "./LgFinderPageTipoAlteracao.vue?vue&type=template&id=58722d43"
import script from "./LgFinderPageTipoAlteracao.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoAlteracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports